import { GrpcCurrency } from '@m/types/grpc/GrpcTypes';

export function formatGrpcToCurrency(currency?: GrpcCurrency): number {
  const { units = '0', nanos = 0 } = currency || {};
  const unitsAsNumber = parseFloat(units) || 0;
  const cents = nanos / 1e9;
  return unitsAsNumber + cents;
}

export function formatCurrencyToGrpc(amount: number, currencyCode?: string): GrpcCurrency {
  const units = Math.floor(amount);
  const nanos = Math.round((amount - units) * 1e9);
  return {
    units: units.toString(),
    nanos,
    currencyCode: currencyCode || 'USD',
  };
}

export function sumGrpcCurrencies(currencies: GrpcCurrency[]): GrpcCurrency {
  if (currencies.length === 0) {
    return { currencyCode: 'USD', units: '0', nanos: 0 };
  }

  const { totalUnits, totalNanos, currencyCode } = currencies.reduce(
    (acc, curr) => {
      acc.totalUnits += parseInt(curr.units, 10);
      acc.totalNanos += curr.nanos;
      return acc;
    },
    {
      totalUnits: 0,
      totalNanos: 0,
      currencyCode: currencies[0].currencyCode,
    },
  );

  const extraUnits = Math.floor(totalNanos / 1000000000);
  const finalUnits = totalUnits + extraUnits;
  const finalNanos = totalNanos % 1000000000;

  return {
    currencyCode,
    units: finalUnits.toString(),
    nanos: finalNanos,
  };
}

export function subtractGrpcCurrencies(
  minuend: GrpcCurrency,
  subtrahend: GrpcCurrency,
): GrpcCurrency {
  const minuendUnits = parseInt(minuend.units, 10);
  const subtrahendUnits = parseInt(subtrahend.units, 10);

  const minuendNanos = minuend.nanos;
  const subtrahendNanos = subtrahend.nanos;

  let resultUnits = minuendUnits - subtrahendUnits;
  let resultNanos = minuendNanos - subtrahendNanos;

  if (resultNanos < 0) {
    resultUnits -= 1;
    resultNanos += 1000000000;
  }

  return {
    currencyCode: minuend.currencyCode,
    units: resultUnits.toString(),
    nanos: resultNanos,
  };
}
